import { LAST_ACTIVITY_STORAGE_KEY } from "@/core/constants/keys";

export interface ActivityStorage {
  read: () => number | null;
  write: (timestamp: number) => void;
}

/**
 * Única porta de acesso ao localStorage do logout por inatividade. Em iframe, modo privado ou
 * com storage bloqueado, get/set podem lançar: nesse caso vale o valor em memória (só desta aba).
 */
export function createActivityStorage(key = LAST_ACTIVITY_STORAGE_KEY): ActivityStorage {
  let inMemory: number | null = null;

  return {
    read() {
      let stored: number | null = null;
      try {
        const raw = localStorage.getItem(key);
        const parsed = raw === null ? Number.NaN : Number(raw);
        stored = Number.isFinite(parsed) ? parsed : null;
      } catch {
        stored = null;
      }

      // O maior vence: outra aba pode ter gravado algo mais novo; e, se a gravação falhou
      // (cota/bloqueio), o valor em memória é o mais recente.
      if (stored === null) return inMemory;
      if (inMemory === null) return stored;
      return Math.max(stored, inMemory);
    },
    write(timestamp) {
      inMemory = timestamp;
      try {
        localStorage.setItem(key, String(timestamp));
      } catch {
        // Sem storage: segue só com a memória.
      }
    },
  };
}
